<div (clickOutside)="showOptions = false">
	<app-business-user-select
		[selectedUserId]="selectedUserId"
		(onSelected)="showOptions = true"
		[disabled]="disabled"
	></app-business-user-select>

	<ng-template #itemTemplate let-item>
		<div>
			<atomic-business-user
				[user]="item"
				size="small"
				[hideBadge]="!item?.id"
			></atomic-business-user>
		</div>
	</ng-template>

	<div class="relative">
		<app-dropdown-options
			[itemGroups]="[{ items: users, template: itemTemplate }]"
			[show]="showOptions"
			class="mt-2"
			(onSelect)="_selected($event)"
			[xposition]="xposition"
		>
		</app-dropdown-options>
	</div>
</div>
